import { createAction, props } from '@ngrx/store';
import { CardType, Payment, PaymentAccount, PaymentMethod, ReservationChargeDetail } from '@uzurv/rideWss/clara';

export const selectPaymentAccount = createAction('[Payment] Select payment account', props<{ paymentAccount: PaymentAccount }>());

export const fetchPaymentAccounts = createAction('[Payment] Fetch payment accounts');

export const refreshPaymentAccounts = createAction('[Payment] Refresh payment accounts', props<{ loggedInUserId: number }>());

export const fetchPaymentAccountsSuccess = createAction(
  '[Payment] Fetch payment accounts success',
  props<{ paymentAccounts: Array<PaymentAccount> }>()
);

export const fetchPaymentAccountsFail = createAction('[Payment] Fetch payment accounts fail', props<{ error: Error }>());

export const setLastUsedPaymentAccount = createAction('[Payment] Set last used payment account', props<{ paymentAccount: PaymentAccount }>());

export const fetchLastUsedPaymentAccountSuccess = createAction(
  '[Payment] Fetch last used payment account success',
  props<{ paymentAccount: PaymentAccount }>()
);

export const fetchLastUsedPaymentAccountFail = createAction('[Payment] Fetch last used payment account fail');

export const addPaymentAccount = createAction(
  '[Payment] Add payment account',
  props<{ paymentAccount: PaymentAccount; cardTypeString: string }>()
);

export const addPaymentAccountSuccess = createAction('[Payment] Add payment account success', props<{ paymentAccount: PaymentAccount }>());

export const addPaymentAccountFail = createAction('[Payment] Add payment account fail', props<{ error: Error }>());

export const updatePaymentAccount = createAction('[Payment] Update payment account', props<{ paymentAccount: PaymentAccount }>());

export const updatePaymentAccountSuccess = createAction(
  '[Payment] Update payment account success',
  props<{ paymentAccount: PaymentAccount }>()
);

export const updatePaymentAccountFail = createAction('[Payment] Update payment account fail', props<{ error: Error }>());

export const makePaymentAccountDefault = createAction(
  '[Payment] Make payment account default',
  props<{ paymentAccount: PaymentAccount }>()
);

export const deletePaymentAccount = createAction('[Payment] Delete payment account', props<{ paymentAccount: PaymentAccount }>());

export const deletePaymentAccountSuccess = createAction(
  '[Payment] Delete payment account success',
  props<{ paymentAccount: PaymentAccount }>()
);

export const deletePaymentAccountFail = createAction('[Payment] Delete payment account fail', props<{ error: Error }>());

export const fetchPaymentMethods = createAction('[Payment] Fetch payment methods');

export const fetchPaymentMethodsSuccess = createAction(
  '[Payment] Fetch payment methods success',
  props<{ paymentMethods: Array<PaymentMethod> }>()
);

export const fetchPaymentMethodsFail = createAction('[Payment] Fetch payment methods fail', props<{ error: Error }>());

export const fetchCardTypes = createAction('[Payment] Fetch card types');

export const fetchCardTypesSuccess = createAction('[Payment] Fetch card types success', props<{ cardTypes: Array<CardType> }>());

export const fetchCardTypesFail = createAction('[Payment] Fetch card types fail', props<{ error: Error }>());

export const fetchOutstandingCharges = createAction('[Payment] Fetch outstanding charges');

export const fetchOutstandingChargesSuccess = createAction(
  '[Payment] Fetch outstanding charges success',
  props<{ charges: Array<ReservationChargeDetail> }>()
);

export const fetchOutstandingChargesFail = createAction('[Payment] Fetch all charges fail', props<{ error: Error }>());

export const submitPaymentForOutstandingCharges = createAction(
  '[Payment] Submit payment for outstanding charges',
  props<{ riderId: number; paymentAccountId: number; charges: Array<ReservationChargeDetail> }>()
);

export const submitPaymentForOutstandingChargesSuccess = createAction(
  '[Payment] Submit payment for outstanding charges success',
  props<{ payment: Payment }>()
);

export const submitPaymentForOutstandingChargesFail = createAction(
  '[Payment] Submit payment for outstanding charges fail',
  props<{ error: Error }>()
);
